var map = {
	"./_base-button.vue": "8339",
	"./_base-card.vue": "cb2a",
	"./_base-control-input.vue": "167b",
	"./_base-data-table-old.vue": "0854",
	"./_base-data-table.vue": "0f96",
	"./_base-date-picker.vue": "eacb",
	"./_base-display-scan.vue": "9a1e",
	"./_base-display-text.vue": "d13f",
	"./_base-gallery.vue": "0381",
	"./_base-icon.vue": "670f",
	"./_base-img-upload.vue": "62bc",
	"./_base-input-text.vue": "9c57",
	"./_base-link.vue": "cbd4",
	"./_base-signature-pad.vue": "43e2",
	"./_base-tab.vue": "dd88",
	"./_base-tabs-item.vue": "b0ba",
	"./_base-tabs.vue": "83c6",
	"./_base-time-picker.vue": "ec7e",
	"./_base-view.vue": "ef91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b526";